/** @jsxImportSource @emotion/react */
import { Button, Typography, useTheme } from '@quickbit/qb-design-system';
import {
  useApproveManualReviewTransaction,
  useRejectManualReviewTransaction,
} from 'api/useTransactionManualReviewApi';

interface Props {
  transactionId: string;
  onApprove?: () => void;
  onReject?: () => void;
}

export const ManualReviewButtons = ({
  transactionId,
  onApprove,
  onReject,
}: Props) => {
  const { spacing, palette } = useTheme();
  const {
    mutate: approveTransaction,
    error: approveError,
    isPending: isApproving,
  } = useApproveManualReviewTransaction(transactionId, onApprove);
  const {
    mutate: rejectTransaction,
    error: rejectError,
    isPending: isRejecting,
  } = useRejectManualReviewTransaction(transactionId, onReject);

  const error = approveError || rejectError;

  if (error) {
    return (
      <Typography color={palette.danger.default}>
        {error.errorMessage}
      </Typography>
    );
  }

  const shouldBeDisabled = isApproving || isRejecting;

  return (
    <div css={{ display: 'flex', gap: spacing.xxs }}>
      <Button
        text="Approve"
        onClick={() => {
          approveTransaction();
        }}
        disabled={shouldBeDisabled}
        loading={isApproving}
      />
      <Button
        text="Reject"
        variant="secondary"
        onClick={() => {
          rejectTransaction();
        }}
        disabled={shouldBeDisabled}
        loading={isRejecting}
      />
    </div>
  );
};
